import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class FormRentalHouse extends Component {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    rentalHouse: PropTypes.object,

    createRentalHouse: PropTypes.func,
    updateRentalHouse: PropTypes.func,
    deleteRentalHouse: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      name: "",
      address: "",
      phone: "",
      email: "",
      manager: "",
      logo: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.rentalHouse);
    }
  }

  init(rentalHouse) {
    this.setState({
      loading: false,
      name: rentalHouse ? rentalHouse.name : "",
      address: rentalHouse ? rentalHouse.address : "",
      phone: rentalHouse ? rentalHouse.phone : "",
      email: rentalHouse ? rentalHouse.email : "",
      manager: rentalHouse ? rentalHouse.manager : "",
      logo: rentalHouse ? rentalHouse.logo : "",
    });
  }

  handleChange = (name) => (event) => {
    const value = event.target.value;

    this.setState({
      [name]: value,
    });
  };

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: `Are you sure ?`,
        subtitle:
          "If you delete this rentalHouse, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const { deleteRentalHouse, close, refresh, rentalHouse } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteRentalHouse(rentalHouse.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "RentalHouse has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const {
      updateRentalHouse,
      createRentalHouse,
      rentalHouse,
      refresh,
      close,
    } = this.props;

    const { name, address, phone, email, manager, logo } = this.state;

    const { NotificationCenter } = this.context;

    let resp = undefined;
    this.setState({ loading: true });
    if (rentalHouse) {
      resp = await updateRentalHouse(rentalHouse.id, {
        name,
        address,
        phone,
        email,
        manager,
        logo,
      });
    } else {
      resp = await createRentalHouse({
        name,
        address,
        phone,
        email,
        manager,
        logo,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: rentalHouse
          ? "RentalHouse has been updated."
          : "RentalHouse has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const { classes, fullScreen, open, rentalHouse, close } = this.props;

    const { name, address, phone, email, manager, logo, loading } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        onClose={close}
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {rentalHouse
                ? `${rentalHouse.name}`
                : "Let's Create a New RentalHouse"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {rentalHouse
                  ? "To update the rentalHouse, fill the form below :"
                  : "To create a new rentalHouse, fill the form below :"}
              </DialogContentText>
              <Grid container spacing={24}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    label="Name *"
                    className={classes.textField}
                    value={name}
                    onChange={this.handleChange("name")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="address"
                    label="Address"
                    className={classes.textField}
                    value={address}
                    onChange={this.handleChange("address")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="phone"
                    label="Phone"
                    className={classes.textField}
                    value={phone}
                    onChange={this.handleChange("phone")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="email"
                    label="Email"
                    className={classes.textField}
                    value={email}
                    onChange={this.handleChange("email")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="manager"
                    label="Manager"
                    className={classes.textField}
                    value={manager}
                    onChange={this.handleChange("manager")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="logo"
                    label="Logo"
                    className={classes.textField}
                    value={logo}
                    onChange={this.handleChange("logo")}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {rentalHouse ? (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} /> Delete
                </Button>
              ) : (
                []
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} /> Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />{" "}
                {rentalHouse ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormRentalHouse));
